import { Home }     from './pages/home.js'
import { Sweep }    from './pages/sweep.js'
import { NotFound } from './pages/notfound.js'

// Parses hash path and optional params, e.g. #/sweep/uuid → { path: '/sweep/uuid', params: { id: 'uuid' } }
function matchRoute(hash) {
  const pathWithQuery = (hash || '#/').slice(1)
  const [path, qs]    = pathWithQuery.split('?')
  const query         = Object.fromEntries(new URLSearchParams(qs || ''))

  // /sweep/:id
  const sweepMatch = path.match(/^\/sweep\/([a-f0-9-]+)$/)
  if (sweepMatch) return { Page: Sweep, params: { id: sweepMatch[1] }, query }

  if (path === '/' || path === '') return { Page: Home, params: {}, query }

  return { Page: NotFound, params: {}, query }
}

export const router = {
  outlet: null,
  mount(outlet) {
    this.outlet = outlet
    this.navigate()
  },
  navigate() {
    if (!this.outlet) return
    const { Page, params, query } = matchRoute(window.location.hash)
    this.outlet.innerHTML = ''
    this.outlet.appendChild(Page({ params, query }))
    window.scrollTo(0, 0)
  },
}
